var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }